import { RelewiseTrackingLine } from '@core/services/relewise/relewise-tracking.model';
import { ReserveProductDetail } from '@features/reserve-in-store/reserve-in-store';

export const mapToRelewiseTrackingLine = (items: ReserveProductDetail[]): RelewiseTrackingLine => {
    if (!items || !items.length) {
        return [];
    }

    return items.map(item => ({
        lineType: 'Normal',
        priceAmountRaw: item.priceAmountRaw || 0,
        variantNo: item.variantNo,
        quantity: item.quantity
    }));
};
